import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import {
  People as PeopleIcon,
  Description as DescriptionIcon,
  Quiz as QuizIcon,
  TrendingUp as TrendingUpIcon,
} from '@mui/icons-material'
import { DashboardCard } from './DashboardCard'
import { AdminDashboardStats } from '../../types/dashboard'

interface SystemOverviewProps {
  stats: AdminDashboardStats
  onUsersClick?: () => void
  onComplianceClick?: () => void
  onTestsClick?: () => void
}

export const SystemOverview: React.FC<SystemOverviewProps> = ({
  stats,
  onUsersClick,
  onComplianceClick,
  onTestsClick,
}) => {
  const { t } = useTranslation('dashboard')

  return (
    <>
      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        {t('overview.systemOverview')}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(4, 1fr)',
          },
          gap: { xs: 2, sm: 3 },
          mb: 4,
        }}
      >
        <DashboardCard
          title={t('overview.totalUsers')}
          value={stats.totalUsers}
          icon={<PeopleIcon />}
          color="primary"
          onClick={onUsersClick}
        />
        <DashboardCard
          title={t('overview.totalRules')}
          value={stats.totalRules}
          icon={<DescriptionIcon />}
          color="secondary"
          onClick={onComplianceClick}
        />
        <DashboardCard
          title={t('overview.totalTests')}
          value={stats.totalTests}
          icon={<QuizIcon />}
          color="primary"
          onClick={onTestsClick}
        />
        <DashboardCard
          title={t('overview.completionRate')}
          value={`${stats.completionRate}%`}
          icon={<TrendingUpIcon />}
          color="primary"
        />
      </Box>
    </>
  )
}
